module.exports = __webpack_public_path__ + "images/internal/review_widgets/widget_type/embeddable.svg";